<template>
  <v-autocomplete
    persistent-hint
    class="mt-0"
    clearable
    :label="label"
    :loading="loading || qbLoading"
    :disabled="disabled"
    item-text="selectDisplay"
    :items="entries"
    return-object

    v-bind="$attrs"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)">

    <template slot="item" slot-scope="slotItems">
      <v-layout column>
        <div class="title mr-3 mt-1 primary--text">
          <span v-if="customerCompanyName(slotItems.item)">
            <v-icon color="primary" v-if="slotItems.item.qbCompanyId">business</v-icon>
            <!-- Issue #379 -->
            <v-icon color="transparent" v-else>add_circle</v-icon>
            {{ customerCompanyName(slotItems.item) }}
          </span>
          <span v-else>
            <v-icon color="primary">person_outline</v-icon>
            {{ customerDisplayName(slotItems.item) }}
          </span>
        </div>
        <div class="grey--text caption"
             v-if="customerCompanyName(slotItems.item) && customerContactName(slotItems.item)">
          <v-icon color="primary">person_outline</v-icon>
          <span>{{ customerContactName(slotItems.item) }}</span>
          <span v-if="customerCompanyName(slotItems.item) !== customerDisplayName(slotItems.item)"
                class="font-italic font-weight-light">
            {{ customerDisplayName(slotItems.item) }}
          </span>
        </div>

      </v-layout>
    </template>

    <template slot="append-outer">
      <v-btn fab small flat
             color="accent"
             class="ma-0"
             :loading="loading || qbLoading"
             @click="refresh()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
import QuickbooksMixin from '@/mixins/quickbooksMixin';

export default {
  name: 'VSelectQuickbooksCompany',
  mixins: [
    QuickbooksMixin,
  ],
  data() {
    return {
    };
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    vendor: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.vendor ? 'Select Vendor' : 'Select Customer';
    },
    vendors() {
      return this.quickbooksVendors(this.company.id);
    },
    customers() {
      return this.quickbooksCustomers(this.company.id);
    },
    entries() {
      if (this.vendor) {
        return this.vendors;
      }

      if (this.customer) {
        return this.customers;
      }

      return undefined;
    },
    qbLoading() {
      if (this.vendor) {
        return this.vendorsStatus[this.company.id];
      }
      if (this.customer) {
        return this.customersStatus[this.company.id];
      }

      return false;
    },
  },
  methods: {
    refresh() {
      if (this.vendor) {
        this.refreshQuickbooksVendors(this.company.id);
      } else {
        this.refreshQuickbooksCustomers(this.company.id);
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/qb/SelectQuickbooksCompany.vue